<template>
  <div class="accident-amount-modal">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="dialog-inner">
        <el-tabs v-model="activeName">
          <el-tab-pane label="累计事故" name="0"></el-tab-pane>
          <el-tab-pane label="昨日事故" name="1"></el-tab-pane>
          <el-tab-pane label="本周事故" name="2"></el-tab-pane>
          <el-tab-pane label="本月事故" name="3"></el-tab-pane>
        </el-tabs>

        <div v-if="currentData" class="accident-amount-detail">
          <div class="accident-amount-row" v-for="(item, index) in currentData.dataList" :key="index">
            <div class="accident-amount-name" @click="handleDataValueClick(item.clickCallback)">{{item.name}}</div>
            <div class="accident-amount-value">
              {{item.value}}
              <span v-if="index > 0" class="accident-amount-ratio">({{(item.ratio * 100).toFixed(2) + '%'}})</span>
            </div>
            <div class="data-change-situation-list" v-if="Array.isArray(item.ratioList) && item.ratioList.length">
              <p class="data-change-situation" v-for="(item, index) in item.ratioList" :key="index">
                <span class="situation-label">{{item.name}}</span>
                <i :class="{
                  'situation-icon': true,
                  increase: item.value > 0,
                  decrease: item.value < 0
                }"></i>
                <span :class="{
                  'situation-value': true,
                  increase: item.value > 0,
                  decrease: item.value < 0
                }">{{item.value === null || typeof item.value === 'undefined' ? '--' : (item.value * 100).toFixed(2).replace('-', '') + '%'}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeName: '0',
      dialogVisible: false,
    }
  },
  computed: {
    currentData() {
      if (this.activeName === '0') {
        return this.data.data.total
      } else if (this.activeName === '1') {
        return this.data.data.day
      } else if (this.activeName === '2') {
        return this.data.data.week
      } else if (this.activeName === '3') {
        return this.data.data.month
      }
      return this.data.data.total
    },
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleConfirm() {
      this.dialogVisible = false
    },
    handleDataValueClick(callback) {
      typeof callback === 'function' && callback()
    },
  },
  created() {

  },
}
</script>

<style lang="scss" scoped>
.accident-amount-modal {
  ::v-deep .el-dialog__body {
    margin-top: 0;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 24px;
  }
}
.dialog-inner {
  padding: 8px 8px 0 8px;
  .accident-amount-detail {
    display: flex;
    flex-direction: column;
    .accident-amount-row {
      display: flex;
      margin: 0 0 24px 0;
      .accident-amount-name {
        flex: none;
        width: 84px;
        font-size: 14px;
        font-weight: normal;
        line-height: 22px;
        text-align: right;
        color: #3D3D3D;
      }
      .accident-amount-value {
        margin-left: 20px;
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
        .accident-amount-ratio {
          color: #767676;
        }
      }
    }
  }
  .data-change-situation-list {
    display: flex;
    align-items: center;
    margin-left: 32px;
    .data-change-situation {
      margin: 0 24px 0 0;
      display: flex;
      align-items: center;
      .situation-label {
        flex: none;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .situation-icon {
        flex: none;
        margin: 0 2px 0 4px;
        &.increase {
          // position: relative;
          // top: 1px;
          width: 10px;
          height: 7px;
          background: url('../../../../assets/img/ratio_up.png') 0 0 no-repeat;
          background-size: 100%;
        }
        &.decrease {
          // position: relative;
          // top: 0px;
          width: 10px;
          height: 7px;
          background: url('../../../../assets/img/ratio_down.png') 0 0 no-repeat;
          background-size: 100%;
        }
      }
      .situation-value {
        &.increase {
          font-size: 12px;
          font-weight: normal;
          line-height: 14px;
          color: #0FC570;
        }
        &.decrease {
          font-size: 12px;
          font-weight: normal;
          line-height: 14px;
          color: #EA0000;
        }
      }
    }
  }
}
</style>
